import "./RiskDashboardComponent.scss";
import {IComponentOptions} from "angular";
import {RiskDashboardViewStore} from "../store/RiskDashboardViewStore";

export const RiskDashboard = "riskDashboard";

export function riskDashboard(): IComponentOptions {
    return {
        templateUrl: "app/risk/dashboard/components/RiskDashboardComponent.html",
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: RiskDashboardComponentController
    };
}

export class RiskDashboardComponentController {
    public readonly viewStore: RiskDashboardViewStore;
}
